import React from 'react'
import styled from 'styled-components'

export const BannerTopTemplate = ({ data }) => {
  const { info } = data

  return (
    <BannerInfo>{info.bannerinfo}</BannerInfo>
  )
}

const Banner = props => {
  if (!props.data) {
    return null
  }
  const data = props.data.edges[0].node.frontmatter
  return <BannerTopTemplate data={data} />
}

export { Banner }

const BannerInfo = styled.div`
  position: relative;
  width: 100%;
  background: -moz-linear-gradient(120deg, rgba(252,148,57,1) 0%, rgba(116,56,94,1) 100%);
  background: -webkit-linear-gradient(120deg, rgba(213,97,78,1 ) 0%,rgba(116,56,94,1) 100%);
  background: linear-gradient(120deg, rgba(240,225,2,1) 0%,rgba(213,97,78,1) 100%);
  padding: 5px;
  text-align: center;
  font-size: 0.7rem;
  color: #fff;
  font-weight: 900;
  text-transform: uppercase;
`
